import { DeleteOutlined, SaveOutlined, EditOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Table, Tabs, Form, TreeSelect, Space, Col, Row, Tag, Tooltip } from 'antd';
import { currencyFormat, formatVND, validateMessages } from '../../helpers/common';
import Column from 'antd/es/table/Column';
import { PhuCapResponse } from '../../models/hopdong/HopDong';
import { useEffect, useState } from 'react';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { DataSelectBox } from '../../models/selectbox';
import Input from 'antd/es/input/Input';
import { convertDataSelectBox, layDanhMucPhuCap } from '../../services/danhmuc';
import { luuPhuCapNhanSu, xoaPhuCapNhanSu, layTienPhuCap } from '../../services/hopdong';
import { toast } from 'react-toastify';

const PhuCapBox = ({ idHopDong, idQDBL, idChucVu, idDonVi, listData, isThemMoi, onSubmit }: { idHopDong: number, idQDBL:number, idChucVu: number, idDonVi: number, listData?: Array<PhuCapResponse>, isThemMoi?: boolean, onSubmit: () => void }) => {
    const [loading, setLoading] = useState(false);
    const [showModalPhuCap, setShowModalPhuCap] = useState<boolean>(false);
    const [idXoaPCNS, setIdXoaPCNS] = useState<number>(0);
    const [idSuaPCNS, setIdSuaPCNS] = useState<number>(0);
    const [optionPhuCap, setOptionPhuCap] = useState<Array<DataSelectBox>>([]);
    const [form] = Form.useForm();

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            mucPhuCap: parsedValue,
            mucPhuCapStr: format
        });
    };

    const loadDataSelectBoxs = async () => {
        try {
            setLoading(true);
            var phuCap = await layDanhMucPhuCap();
            setOptionPhuCap(convertDataSelectBox(phuCap));
            setLoading(false);
        }
        catch (err: any) {
            setLoading(false);
        }
    }

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            await luuPhuCapNhanSu(values);
            setShowModalPhuCap(false);
            toast.success('Lưu phụ cấp nhân sự thành công!')
        }
        catch (err: any) {
            setShowModalPhuCap(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }

        setLoading(false);
        onSubmit();
    };

    const setFormDetailModal = (value: PhuCapResponse | null) => {
        form.setFieldsValue({
            idHopDong: idHopDong,
            id: value?.idPhuCapNhanSu,
            idPhuCap: value?.idPhuCap,
            mucPhuCap: value?.mucPhuCap || 0,
            mucPhuCapStr: value?.mucPhuCap ? currencyFormat.formatMoney(value?.mucPhuCap) : "" || 0,
            moTa: value?.moTa || "",
            idQuyetDinhBacLuong: idQDBL,
        });

        setShowModalPhuCap(true);
    }

    const xoaPCNS = async () => {
        try {
            setLoading(true);
            await xoaPhuCapNhanSu(idXoaPCNS);
            toast.success('Xoá phụ cấp nhân sự thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoaPCNS(0);
        setLoading(false);
        onSubmit();
    }

    
    const layphucaphientaiclick = async () => {
        try {
            const formValues = await form.validateFields(); // Lấy giá trị từ các trường Form.Item
            const { idPhuCap } = formValues; // Lấy idDonVi, idChucVu, idPhuCap từ formValues
            const response = await layTienPhuCap(idDonVi, idChucVu, idPhuCap);// Gọi hàm layTienPhuCap để lấy thông tin TienPhuCap
            const parsedValue = response.tienPhuCap.toString().replace(/[^0-9]/g, '').trim().replace(/^0+/, '');// Đặt lại giá trị tienPhuCap cho trường Input
            const format = currencyFormat.formatMoney(parsedValue);
            form.setFieldsValue({ mucPhuCapStr: format });
            form.setFieldsValue({ mucPhuCap: response.tienPhuCap });
            toast.success('Lấy cấu hình phụ cấp nhân sự thành công!');
        } catch (error) {
            if (isThemMoi) {
                form.setFieldsValue({ mucPhuCap: 0 });
                form.setFieldsValue({ mucPhuCapStr: 0 });
                toast.warning('Mức phụ cấp này chưa được cấu hình!');
            } else {
                toast.error('Mức phụ cấp bị xảy ra lỗi!');
            }
        }
    };

    useEffect(() => {
        loadDataSelectBoxs();
    }, [])

    return (
        <div className="card-outline">
            {showModalPhuCap && <ModalTextForm title="Phụ cấp nhân sự"
                hideFooter
                show={showModalPhuCap}
                handleClose={() => { setIdSuaPCNS(0); setShowModalPhuCap(false) }}
            >
                <Form
                    layout="vertical"
                    validateMessages={validateMessages}
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item hidden name="id"><Input /></Form.Item>
                    <Form.Item hidden name="idHopDong"><Input /></Form.Item>
                    <Form.Item hidden name="idQuyetDinhBacLuong"><Input /></Form.Item>
                    <Row gutter={35}>
                        <Col span={8}>
                            <Form.Item
                                label="Phụ cấp"
                                name="idPhuCap"
                                rules={[
                                    {
                                        required: true
                                    }
                                ]}
                            >
                                <TreeSelect showSearch treeData={optionPhuCap} loading={loading} allowClear placeholder="Chọn phụ cấp" onChange={layphucaphientaiclick} />
                            </Form.Item>
                        </Col>
                        <Col span={14}>
                            <Form.Item
                                label="Mức phụ cấp"
                                name="mucPhuCapStr"
                                rules={[
                                    {
                                        required: true
                                    }
                                ]}
                            >
                                <Input prefix="₫ " onChange={handleChangeCurrency} />
                            </Form.Item>
                        </Col>
                        <Col span={1}>
                            <Form.Item label>
                                <Tooltip placement="top" title="Cập nhật phụ cấp" >
                                    <Button icon={<ReloadOutlined rev="" />} onClick={layphucaphientaiclick} />
                                </Tooltip>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        
                    </Row>
                    <Form.Item name="mucPhuCap" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Mô tả"
                        name="moTa"
                        rules={[
                            {
                                max: 500
                            }
                        ]}
                    >
                        <Input
                            placeholder="Mô tả"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" className='float-right' htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                            Lưu
                        </Button>
                       
                    </Form.Item>
                </Form>
            </ModalTextForm>}
            {idXoaPCNS > 0 && <ModalTextForm show={idXoaPCNS > 0}
                title="Xoá phụ cấp nhân sự"
                handleClose={() => setIdXoaPCNS(0)}
                handleSave={() => xoaPCNS()}>
                Xác nhận xoá phụ cấp nhân sự  đang chọn
            </ModalTextForm>}
            <Tabs tabBarExtraContent={
                isThemMoi && idQDBL  > 0 &&
                <Button
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                    className="hrm-btn hrm-btn-warning"
                >
                    Thêm mới
                </Button>
            }
                defaultActiveKey="1" items={[
                {
                    key: '1',
                    label: 'Tiền phụ cấp',
                    children:
                        <div className="card">
                            <Table
                                locale={{ emptyText: "Không có dữ liệu" }}
                                pagination={false}
                                rowClassName={(record, index) => {
                                    return (record?.idPhuCapNhanSu === idXoaPCNS || record?.idPhuCapNhanSu == idSuaPCNS) ? "selected-row row-key-" : "";
                                }}
                                dataSource={(listData || []).map((value, index) => { const item = { key: index, ...value }; return item; })}>
                                <Column
                                    width="5%"
                                    title="STT"
                                    key="STT"
                                    align="center"
                                    render={(value, record, index) =>
                                    (
                                        <>
                                            {index + 1}
                                        </>
                                    )
                                    }
                                />

                                <Column width="20%" title="Phụ cấp" key="tenPhuCap" dataIndex="tenPhuCap" />
                                <Column width="20%" title="Loại phụ cấp" key="loaiPhuCap" dataIndex="loaiPhuCap" />
                                <Column width="15%" title="Mức phụ cấp" key="mucPhuCap" render={(value, record, index) =>
                                (
                                    <>
                                        {formatVND(value?.mucPhuCap)}
                                    </>
                                )
                                }
                                />
                                <Column
                                    width="15%"
                                    title="Kiểu phụ cấp"
                                    key="cachTinh"
                                    render={(value: PhuCapResponse) => {
                                        if (value.cachTinh === 1) {
                                            return <Tag color="green">Theo tháng</Tag>;
                                        } else if (value.cachTinh === 0) {
                                            return <Tag color="blue">Theo ngày</Tag>;
                                        } else if (value.cachTinh === 2) {
                                            return <Tag color="gold">Theo năm</Tag>;
                                        } else {
                                            return null;
                                        }
                                    }}
                                />
                                <Column width="20%" title="Mô tả" key="moTa" dataIndex="moTa" />
                                {
                                    isThemMoi &&
                                    <Column width="10%" title="" key="action"
                                        render={(value, record, index) =>
                                        (
                                            <Space>
                                                <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                    icon=<EditOutlined rev="" />
                                                    onClick={() => { setIdXoaPCNS(0); setIdSuaPCNS(value.idPhuCapNhanSu); setFormDetailModal(value); }}
                                                >
                                                    Sửa
                                                </Button>
                                                <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                    onClick={() => { setIdSuaPCNS(0); setIdXoaPCNS(value.idPhuCapNhanSu) }}
                                                    icon=<DeleteOutlined rev="" />
                                                >
                                                    Xóa
                                                </Button>
                                            </Space>
                                        )
                                        }
                                    />
                                }
                            </Table>
                        </div>
                },
            ]}>
            </Tabs>
        </div>
    );
};

export default PhuCapBox;
